import {
  Box, Stack, Typography, Button, CircularProgress,
  Dialog, FormControl, FormControlLabel, Radio,
  RadioGroup, Paper, Divider, useTheme
} from '@mui/material';
import { motion } from 'framer-motion';
import { TextFieldMask } from '../../../utils/TextfieldMask/TextfieldMask';
import { green, red } from '@mui/material/colors';
import { useEffect, useState } from 'react';
import { carregarPorWhere, inserirCliente, salvarCarteira } from '../../../controllers/crm/carteiraController';
import dayjs from 'dayjs';
import { formatPhoneNumber } from '../../../utils/formatPhoneNumber';

export default function NovoCliente({
  account,
  open,
  onClose,
  setSnackbar,
  onSuccess
}) {
  const [loading, setLoading] = useState(false);
  const [cliente, setCliente] = useState({
    idcliente: null,
    idconta: account.conta,
    idoperador: account.id,
    idusuario: account.id,
    nome: '',
    telefone: '',
    email: '',
    recproposta: true
  });
  const [nome, setNome] = useState('');
  const [telefone, setTelefone] = useState('');
  const [email, setEmail] = useState('');
  const [nascimento, setNascimento] = useState('');
  const [observacao, setObservacao] = useState('');
  const [recProposta, setRecProposta] = useState(true);
  const [msgErro, setMsgErro] = useState([]);
  const [clienteExistente, setClienteExistente] = useState({});
  const [showLoadClientExistente, setShowLoadClientExistente] = useState(false);
  const [filterExistente, setFilterExistente] = useState('');
  const [showClienteExistente, setShowClienteExistente] = useState(false);

  const theme = useTheme();

  async function loadExistClient() {
    setLoading(true);
    const filtro = filterExistente.split(' ')[0];
    let query = {
      where: {
        idconta: account.conta
      },
      include: {
        operador: {
          select: {
            nome: true,
            telefone: true
          }
        }
      }
    };

    if (filtro === 'email') {
      query.where.email = email;
    }
    if (filtro === 'telefone') {
      query.where.telefone = telefone;
    }
    setShowLoadClientExistente(true);
    const dados = await carregarPorWhere(query);
    if (dados.status === 200) {
      if (dados.data.data.length === 0) {
        setSnackbar({ open: true, message: 'Cliente não encontrado', severity: 'error' });
        setLoading(false);
        return;
      }
      dados.data.data[0].dtnascimento = dados.data.data[0].dtnascimento ? dayjs(dados.data.data[0].dtnascimento).format('DD/MM/YYYY').toString() : null;
      setClienteExistente(dados.data.data[0]);
      setShowClienteExistente(true);
      setLoading(false);
      return;
    } else {
      setSnackbar({ open: true, message: 'Erro ao carregar cliente existente', severity: 'error' });
      setLoading(false);
      return;
    }
  }

  function handleClose() {
    resetForm();
    onClose();
  }

  function resetForm() {
    setNome('');
    setTelefone('');
    setEmail('');
    setNascimento('');
    setObservacao('');
    setRecProposta(true);
    setCliente({
      idcliente: null,
      idconta: account.conta,
      idoperador: account.id,
      idusuario: account.id,
      nome: '',
      telefone: '',
      email: '',
      recproposta: true
    });
    setShowLoadClientExistente(false);
    setShowClienteExistente(false);
  }

  function validar(_dados) {
    const erros = [];
    if (!_dados.nome) {
      erros.push('Nome inválido, favor preencher');
    }
    if (!_dados.telefone) {
      erros.push('Telefone inválido, favor preencher');
    }
    if (_dados.dtnascimento) {
      if (!dayjs(_dados.dtnascimento, 'DD/MM/YYYY', true).isValid()) {
        erros.push('Data de nascimento inválida, favor preencher');
      } else _dados.dtnascimento = dayjs(_dados.dtnascimento, 'DD/MM/YYYY').toISOString();
    }

    setMsgErro(erros);
    return erros.length === 0;
  }

  async function handleSave() {
    setLoading(true);

    const novoCliente = {
      ...cliente,
      telefone: formatPhoneNumber(cliente.telefone, false)
    };

    try {
      if (!validar(novoCliente)) {
        let msg = '';
        msgErro.forEach((item) => {
          msg += item + ';\n';
        });
        setSnackbar({ open: true, message: msg, severity: 'error' });
        setLoading(false);
        return;
      }

      const retorno = await inserirCliente(novoCliente);
      
      if (retorno.status === 201 && retorno.data.success) {
        setSnackbar({ open: true, message: 'Cliente cadastrado com sucesso', severity: 'success' });
        resetForm();
        if (onSuccess) onSuccess();
        onClose();
      } else {
        if (retorno.data.message.includes('existente')) {
          setShowLoadClientExistente(true);
          setFilterExistente(retorno.data.message);
        }
        setSnackbar({ open: true, message: retorno.data.message, severity: 'error' });
      }
    } catch (error) {
      console.error("Erro ao salvar cliente:", error);
      setSnackbar({ open: true, message: 'Erro ao salvar cliente', severity: 'error' });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && (
        <Box sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(4px)',
          zIndex: 9999
        }}>
          <CircularProgress />
        </Box>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: '90vh'
          }
        }}
      >
        <Paper
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          sx={{
            width: '100%',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            bgcolor: 'background.paper',
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              p: 2,
              bgcolor: theme.palette.primary.light,
              borderBottom: 1,
              borderColor: 'divider'
            }}
          >
            <Typography variant="h5" fontWeight="bold">
              NOVO CLIENTE
            </Typography>
          </Box>

          <Stack
            spacing={2}
            sx={{
              p: { xs: 2, md: 3 },
              overflow: 'auto',
              flex: 1
            }}
          >
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextFieldMask
                fullWidth
                label="Nome"
                value={nome || ''}
                onChange={(e) => {
                  setNome(e.target.value);
                  setCliente({ ...cliente, nome: e.target.value })
                }}
                mask={'nome'}
              />
              <TextFieldMask
                label="Telefone"
                value={telefone || ''}
                onChange={(e) => {
                  setTelefone(e.target.value);
                  setCliente({ ...cliente, telefone: e.target.value })
                }}
                mask={'phone'}
              />
            </Stack>

            <TextFieldMask
              fullWidth
              label="Email"
              value={email || ''}
              onChange={(e) => {
                setEmail(e.target.value);
                setCliente({ ...cliente, email: e.target.value })
              }}
              mask={'email'}
            />

            <TextFieldMask
              fullWidth
              label="Data de Nascimento"
              placeholder='dd/mm/aaaa'
              value={nascimento || ''}
              onChange={(e) => {
                setNascimento(e.target.value);
                setCliente({
                  ...cliente,
                  dtnascimento: e.target.value ? e.target.value : null
                })
              }}
              mask={'date'}
            />

            <TextFieldMask
              fullWidth
              multiline
              rows={3}
              label="Observação"
              value={observacao || ''}
              onChange={(e) => {
                setObservacao(e.target.value);
                setCliente({ ...cliente, observacao: e.target.value })
              }}
              mask={'text'}
            />

            <FormControl>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Receber novas propostas:
              </Typography>
              <RadioGroup
                row
                value={recProposta}
                onChange={(e) => {
                  setRecProposta(e.target.value);
                  setCliente({ ...cliente, recproposta: e.target.value === "true" })
                }}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio size='small' />}
                  label="Sim"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio size='small' />}
                  label="Não"
                />
              </RadioGroup>
            </FormControl>
          </Stack>

          <Divider />
          <Stack
            direction="row"
            spacing={2}
            justifyContent={'flex-end'}
            sx={{
              p: 2,
              bgcolor: 'background.paper'
            }}
          >
            <Button
              variant="contained"
              onClick={loadExistClient}
              disabled={loading}
              size='small'
              sx={{ visibility: !showLoadClientExistente ? 'hidden' : 'visible' }}
            >
              Ver existente
            </Button>
            <Button
              variant="contained"
              onClick={handleSave}
              disabled={loading}
              size='small'
            >
              Salvar
            </Button>
            <Button
              variant="outlined"
              onClick={handleClose}
              disabled={loading}
              size='small'
            >
              Sair
            </Button>
          </Stack>
        </Paper>
      </Dialog>

      <Dialog
        open={showClienteExistente}
        onClose={() => setShowClienteExistente(false)}
        PaperProps={{
          sx: {
            width: { xs: '100%', md: '500px' },
            maxHeight: '80vh'
          }
        }}
      >
        <Paper sx={{ p: 0 }}>
          <Box
            sx={{
              p: 2,
              bgcolor: green[100],
              borderBottom: 1,
              borderColor: 'divider'
            }}
          >
            <Typography variant="h5" fontWeight="bold">
              CLIENTE JÁ EXISTE
            </Typography>
          </Box>

          <Stack spacing={2} sx={{ p: 2 }}>
            <Stack spacing={1}>
              {[
                { label: 'Nome', value: clienteExistente.nome },
                { label: 'Telefone', value: clienteExistente.telefone },
                { label: 'Email', value: clienteExistente.email },
                {
                  label: 'Data de Nascimento',
                  value: clienteExistente?.dtnascimento ?
                    dayjs(clienteExistente.dtnascimento).format('DD/MM/YYYY') :
                    '-'
                },
                { label: 'Observação', value: clienteExistente.observacao || '-' },
                {
                  label: 'Receber novas propostas',
                  value: clienteExistente.recproposta ? 'Sim' : 'Não'
                },
                {
                  label: 'Corretor',
                  value: clienteExistente.operador?.nome || '-'
                }
              ].map(({ label, value }) => (
                <Stack key={label} spacing={0.5}>
                  <Typography variant="caption" color="text.secondary">
                    {label}
                  </Typography>
                  <Typography variant="body2">
                    {value}
                  </Typography>
                </Stack>
              ))}
            </Stack>

            <Stack direction="row" spacing={2} sx={{ mt: 2 }} justifyContent="flex-end">
              <Button
                variant="outlined"
                onClick={() => {
                  setShowClienteExistente(false);
                  setShowLoadClientExistente(false);
                }}
                disabled={loading}
                size='small'
              >
                Fechar
              </Button>
            </Stack>
          </Stack>
        </Paper>
      </Dialog>
    </>
  );
}
